// Thirdparty
import 'lightgallery.js/dist/css/lightgallery.css'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-fade'
import 'swiper/css/mousewheel'
import 'swiper/css/scrollbar'
import 'swiper/css/thumbs'

// Theme
import './styles/index.css'

// Thirdparty
import 'what-input'
import 'lightgallery.js/dist/js/lightgallery.js'
import 'lg-thumbnail.js/dist/lg-thumbnail.js'

import throttle from 'lodash/throttle'

/*
 * Script loader
 *
 * Imports and runs all scripts in the `./scripts` directory
 * Scripts must have a default export with `can` and `run` functions
 *
 *    export default {
 *      can: () => boolean,
 *      run: function to run if `can` is true
 *    }
 */
document.addEventListener('DOMContentLoaded', () => {
  ;((r) => {
    r.keys()
      .reduce((modules, script) => {
        const module = r(script).default
        if (module) {
          modules.push(module)
        }
        return modules
      }, [])
      .map((module) => (module.can === true || module.can()) && module.run())
  })(require.context('scripts', true, /^(?!.*(common|react)).*\.js$/))

  document.documentElement.classList.remove('_preload')

  const setHeights = () => {
    const siteHeader = document.querySelector('.site-header')

    if (siteHeader) {
      document.documentElement.style.setProperty('--site-header-height', `${siteHeader.offsetHeight}px`)
    }
  }

  setHeights()

  window.addEventListener('resize', throttle(setHeights, 250))

  // Update all youtube iframes on the page to include ?rel=0
  document.querySelectorAll('iframe').forEach((el) => {
    const src = el.src

    if (src.includes('?feature=oembed')) {
      el.src = src.replace('?feature=oembed', '?rel=0')
    }
  })
})
